import React from "react"

import ModalV4Header from "../../../../../app/ui/modal/v4/header/v4-header"


export default function ModalMoveTo_SubtasksError() {

    const stopPropagation = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        e.preventDefault()
    }

    const closeModal = () => {
        gd.modal.hide()
    }

    return (
        <div className="v4-container placement-middle" onClick={stopPropagation}>
            <ModalV4Header height   = {114}
                           onClose  = {closeModal}
                           title    = "Select parent task"/>

            <div className="error-message">
                This task already has subtasks and cannot be converted to subtask itself.
            </div>
        </div>
    )
}